import * as endpoints from '@App/constants/endpoints';
import interceptor from '../interceptor';
import axiosRef from 'axios';

import { get, del, post, put } from '../util';

const MODELS = 'models';
const INACTIVATE = 'inactivate';
const LIST = 'list';
const PUBLISHED = 'published';
const MANAGER = 'manager';
const MANY_DOCS = 'manyDocs';

//#region GET
export const getDocsModels = async ({ header }) => {
  const pathUrl = `${endpoints.API_DOCS}/${MANAGER}/${MODELS}`;
  const axios = interceptor(header);
  return await get(axios, pathUrl);
};

export const getDocModelById = async ({ header, docModelId }) => {
  const pathUrl = `${endpoints.API_DOCS}/${MANAGER}/${MODELS}/${docModelId}`;
  const axios = interceptor(header);
  return await get(axios, pathUrl);
};

export const getDocsModelsPublished = async ({ header }) => {
  const pathUrl = `${endpoints.API_DOCS}/${MANAGER}/${MODELS}/${LIST}/${MODELS}/${PUBLISHED}`;
  const axios = interceptor(header);
  return await get(axios, pathUrl);
};

export const duplicateModelDocById = async ({ header, docModelId }) => {
  const pathUrl = `${endpoints.API_DOCS}/${MANAGER}/${MODELS}/duplicateModel/${docModelId}`;
  const axios = interceptor(header);
  return await get(axios, pathUrl);
};
//#endregion /list/models/published

//#region POST
export const createDocModel = async ({ header, params }) => {
  const pathUrl = `${endpoints.API_DOCS}/${MANAGER}/${MODELS}`;
  const axios = interceptor(header);
  return await post(axios, pathUrl, params);
};
//#endregion

//#region PUT
export const updateDocModel = async ({ header, params }) => {
  const pathUrl = `${endpoints.API_DOCS}/${MANAGER}/${MODELS}`;
  const axios = interceptor(header);
  return await put(axios, pathUrl, params);
};

export const updateManyDocModel = async ({ header, params }) => {
  const pathUrl = `${endpoints.API_DOCS}/${MANAGER}/${MODELS}/${MANY_DOCS}`;
  const axios = interceptor(header);
  return await put(axios, pathUrl, params);
};

export const inactivateDocModel = async ({ header, params }) => {
  const pathUrl = `${endpoints.API_DOCS}/${MANAGER}/${MODELS}/${INACTIVATE}`;
  const axios = interceptor(header);
  return await put(axios, pathUrl, params);
};
//endregion

//#region DELETE
export const deleteDocModel = async ({ header, params }) => {
  const pathUrl = `${endpoints.API_DOCS}/${MANAGER}/${MODELS}`;
  const axios = interceptor(header);
  return await del(axios, pathUrl, params);
};
//endregion
